export interface Offer {
  id: string;
  name?: string;
  formId: string;
  payoff: string;
  description?: string;
  price?: string;
  tags?: any;
  type?: string;
  logo?: string;
  timestamp?: string;
  bestOffer?: boolean;
}

export abstract class OfferData {
  abstract createOffer(Offer: Offer);
  abstract getOffers(pagination, filter, order);
  abstract getOffer(id: string);
  abstract editOffer(data: Offer, id: string);
  abstract deleteOffer(id: string);
}
